import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { Eyebrow, Reveal } from "./Reveal";

const FAQS = [
  {
    q: "Will anyone in my office know you were here?",
    a: "Who is informed is your decision. Attendance is arranged to avoid identifying the visit: unmarked vehicles, no branded cases, and a time set by you.",
  },
  {
    q: "What is the difference between a bug sweep and TSCM?",
    a: "A bug sweep is the common name for an inspection of a room, vehicle or home for hidden devices. TSCM, technical surveillance countermeasures, is the discipline that inspection belongs to: radio, electronic and physical methods, and a report of what was found.",
  },
  {
    q: "How quickly can someone attend?",
    a: "We do not publish a fixed attendance time. The date depends on the city and the size of the space and is agreed on the call. We contact you within 12 hours at most of your enquiry.",
  },
  {
    q: "What does it cost?",
    a: "Pricing follows the area covered and the methods required. We quote after a scoping conversation, not before it.",
  },
  {
    q: "How often should a company do this?",
    a: "We recommend scheduled inspections through the year, and one before each board sitting or transaction discussion. What suits you depends on how often the space is left unattended and who has access to it.",
  },
  {
    q: "Is this the same as cybersecurity?",
    a: "No. Technical surveillance countermeasures deal with the physical space and its radio environment: devices placed in a room, a vehicle or a fixture. They are not a review of your network. We can also check phones and laptops for spyware; this is scoped separately from the room inspection, and the scope is agreed on the call.",
  },
  {
    q: "What if you find something?",
    a: "We report it to you. What you do next depends on your situation and is yours to decide with your own counsel; we do not apply one fixed procedure. The report records what was found and where.",
  },
  {
    q: "What do I receive afterwards?",
    a: "A written report and a verbal debrief, covering the space examined, the methods used, what was found and what we recommend. It is written in plain language so that a board or a legal team can read it.",
  },
  {
    q: "What do you need to know about the meeting?",
    a: "At minimum, the venue and the time at which we are to attend. For a date and a quote we also ask which areas are to be inspected and roughly how large they are. Why you are commissioning it is optional.",
  },
  {
    q: "What do you keep afterwards?",
    a: "You keep one copy of the findings and notes. Our copy is held encrypted and kept for about a year, then destroyed.",
  },
  {
    q: "Can a hotel meeting room be made secure?",
    a: "It can be inspected, and that is worth doing, but an inspection reduces risk rather than removing it: you do not control the venue, the staff, or who used the room the day before. For high-stakes discussions in a venue you do not control, an inspection followed by monitoring through the meeting is an option.",
  },
  {
    q: "Does a clean sweep guarantee the room is secure?",
    a: "No. An inspection reports what was found within the conditions and limits recorded at the time. It confirms a space at a point in time, and what enters the room afterwards is a separate question.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-12 sm:py-16" data-testid="faq-section">
      <div className="site-x">
        <Reveal>
          <Eyebrow>Questions</Eyebrow>
          <h2 className="mt-4 font-head font-extrabold tracking-tight h-sec">
            Asked often, answered plainly.
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-10">
            {FAQS.map(({ q, a }, i) => (
              <AccordionItem
                key={q}
                value={`item-${i}`}
                className="border-b border-hairline"
                data-testid={`faq-item-${i + 1}`}
              >
                <AccordionTrigger
                  className="py-5 text-left font-head text-base font-bold text-ink hover:text-violet hover:no-underline sm:text-lg"
                  data-testid={`faq-trigger-${i + 1}`}
                >
                  {q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-[0.9375rem] leading-relaxed text-sub">
                  {a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
